<template>
  <li
    class="flex flex-col hover:bg-navy-600"
    :class="{
      'bg-navy-600': isOpen || isCurrentPage,
      'mr-8 rounded-r-lg': showLabel
    }"
  >
    <component
      :is="item.children ? 'button' : Link"
      v-bind="item.children ? {} : { href: item.href }"
      @click="onClickItem"
      class="flex gap-x-4 items-center font-medium pl-6.5 py-3 text-gray-100 hover:text-gray-100"
    >
      <component
        v-if="item.icon"
        :is="item.icon"
        width="22"
        height="22"
        class="w-[22px] h-[22px] text-navy-200 shrink-0"
      />
      <transition>
        <span v-if="showLabel">{{ item.name }}</span>
      </transition>
    </component>
    <ol
      v-if="item.children"
      class="pl-[63px] text-xs transition-all duration-200 ease-in-out-circ overflow-hidden relative -top-2"
      :class="{
        'hidden opacity-0': !isOpen,
        'opacity-1': isOpen
      }"
      :style="showLabel && isOpen ? `height:${item.children.length * 18 + 6}px;` : `height:0;`"
    >
      <li
        v-for="(subItem, index) in item.children"
        class="truncate pr-3 pb-0.5"
        :class="[isCurrentPage?.child === index ? 'text-gray-100' : 'text-navy-200']"
      >
        <a
          class="hover:text-gray-200 cursor-pointer"
          :class="[isCurrentPage?.child === index ? 'text-gray-100' : 'text-navy-200']"
          :href="subItem.href"
          @click.prevent="() => onClickSubItem(subItem)"
        >
          {{ subItem.name }}
        </a>
      </li>
    </ol>
  </li>
</template>

<style scoped>
.pl-\[63px\] {
  padding-left: 63px;
}
.pl-6\.5 {
  padding-left: calc(theme('spacing.4') + theme('spacing[2.5]'));
}
.w-\[22px\] {
  width: 22px;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 100ms ease;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.v-leave-active {
  transition-delay: 100ms;
}
</style>

<script setup>
import { ref, computed } from 'vue'
import { router, Link } from '@inertiajs/vue3'

const props = defineProps({
  item: {
    type: Object,
    default: () => {}
  },
  showLabel: {
    type: Boolean,
    default: true
  }
})

const onClickItem = () => {
  isOpen.value = !isOpen.value
}

const onClickSubItem = (subItem) => {
  if (subItem?.isFullPageLoad ?? false) {
    location.href = subItem.href
  } else {
    router.visit(subItem.href)
  }
}

const isCurrentPage = computed(() => {
  const curRoute = route().current()

  if (props.item.route === curRoute) {
    return { parent: true }
  }

  if (props.item.children) {
    const childIndex = props.item.children.findIndex((child) => {
      return child.route === curRoute
    })
    if (childIndex >= 0) {
      return { child: childIndex }
    }
  }

  return false
})

const isOpen = ref(isCurrentPage.value)
</script>
